export enum TestStatuses {
  NEW = 'New',
  COMPLETED = 'Completed',
  INPROGRESS = 'In Progress',
  REVIEW = 'Review'
}

export enum UserStatuses {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  PENDING = 'pending',
  TRIAL = 'trial',
  EXPIRED = 'expired'
}

export enum FastNoteHintEnum {
  Focus = 'Focus',
  Important = 'Important',
  DiscussWithTeam = 'Discuss with Team',
  ReviewLater = 'Review Later',
  Reference = 'Reference',
  Revisit = 'Revisit',
  CheckDetails = 'Check Details',
  Reminder = 'Reminder',
  HighPriority = 'High Priority',
  LowPriority = 'Low Priority'
}

// Define the enum for content types
export enum QuizGeneratorContentType {
  Text = 'Text',
  Document = 'Document',
  Video = 'Video',
  Topic = 'Topic'
}

export enum UserRoles {
  RESIDENT = 'resident',
  DIRECTOR = 'director'
}

export enum TestTypes {
  SYSTEM_INITIAL = 'System',
  USER_SIMPLE_ADAPTIVE = 'Quick',
  USER_CUSTOM_ADAPTIVE = 'User',
  ASSIGNED = 'Assigned'
}

export enum TestMode {
  TUTOR = 'Tutor',
  TIMED = 'Timed',
  UNTIMED = 'Untimed'
}

export enum ChatActions {
  DATA = 'data',
  QUESTION = 'question'
}
